import React, { useEffect, useState } from "react";

import { IconName } from "../types";
import Icon from "./Icon";

const FullscreenModal = (props: {
  title: string;
  onClose: () => void;
  closing?: boolean;
  children?: JSX.Element;
}) => {
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (props.closing) {
      onClickClose();
    }
  }, [props.closing]);

  const onClickClose = () => {
    setIsClosing(true);
    setTimeout(function () {
      // Wait for fade out.
      // It is expected that the parent component will remove the Modal
      // from the DOM when onClose() is called
      props.onClose();
    }, 600);
  };
  return (
    <div className={`pyht-fullscreen-modal ${isClosing ? "closing" : ""}`}>
      <div className={"container header"}>
        <h2 className={"h1"}>{props.title}</h2>

        <div
          className={"close-btn"}
          role={"button"}
          onClick={() => onClickClose()}
        >
          <Icon name={IconName.TIMES} />
        </div>
      </div>
      <div className={"content"}>{props.children}</div>
    </div>
  );
};

export default FullscreenModal;
